import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";
import { LangProvider } from "@/i18n";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import MottaronePage from "@/pages/MottaronePage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import AdminPage from "@/pages/AdminPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import CookieBanner from "@/components/CookieBanner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function VisitTracker() {
  const location = useLocation();

  useEffect(() => {
    try {
      if (location.pathname.startsWith("/admin")) return;
      const metrics = [];
      if (!sessionStorage.getItem("sl_visit")) {
        sessionStorage.setItem("sl_visit", "1");
        metrics.push("visit");
      }
      if (!localStorage.getItem("sl_vid")) {
        localStorage.setItem("sl_vid", crypto.randomUUID());
        metrics.push("new_visitor");
      }
      if (metrics.length) axios.post(`${API}/track`, { metrics }).catch(() => {});
    } catch { /* tracking best-effort */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      if (location.pathname.startsWith("/prenota") && !sessionStorage.getItem("sl_bkp")) {
        sessionStorage.setItem("sl_bkp", "1");
        axios.post(`${API}/track`, { metrics: ["booking_page"] }).catch(() => {});
      }
    } catch { /* ignore */ }
  }, [location.pathname]);

  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition">
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/prenota/mottarone" element={<MottaronePage />} />
        <Route path="/prenota/:tourType" element={<BookingPage />} />
        <Route path="/conferma/:bookingId" element={<ConfirmationPage />} />
        <Route path="/conferma" element={<ConfirmationPage />} />
        <Route path="/admin-dashboard" element={<AdminPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <div className="noise-overlay min-h-screen bg-[#0a1a0f]">
        <BrowserRouter>
          <VisitTracker />
          <AnimatedRoutes />
          <CookieBanner />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: '#0f2518',
              border: '1px solid #1a4a2e',
              color: '#e8f0e8',
              borderRadius: '8px',
            },
          }}
        />
      </div>
    </LangProvider>
  );
}

export default App;
